import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "./Base";

export const GET_GEOGRAPHIC_AREAS_TAG = "get_areas";

@Component
export default class GeographicArea extends Base {
  getGeographicAreas() {
    const path = `${API_ENDPOINT}/areas`;
    return this.$store.dispatch("http/request", {
      tag: GET_GEOGRAPHIC_AREAS_TAG,
      url: path,
      method: "GET",
    });
  }
}
